import { useMemo } from "react";

import { partition } from "lodash-es";

import { InternalFieldDescription } from "@app/store/recordPreview/EntityColumnsConfiguration";
import { displayOrderComparator } from "@app/util/comparator";

const useFieldAccess = (
  fields: InternalFieldDescription[]
): [InternalFieldDescription[], InternalFieldDescription[], number] => {
  return useMemo(() => {
    const sortedFields = fields.sort(displayOrderComparator);
    const [disabled, allowed] = partition(sortedFields, "disabled");
    const startDisplayOrder = allowed.at(0)?.displayOrder ?? disabled.at(-1)?.displayOrder ?? 0;
    return [disabled, allowed, startDisplayOrder];
  }, [fields]);
};

export default useFieldAccess;
